// gui/src/config/claude.ts

export const CLAUDE_MODELS = {
  // ✅ SUPPORTED MODELS (matches backend claude_config.py):
  // - expert (tier label "Everyday"): claude-sonnet-5 (all plans)
  // - genius (tier label "Smartest"): claude-opus-5   (all plans)
  // Internal keys (expert/genius) are kept stable for backward compatibility
  // with persisted threads/automations — only the user-facing tier label changed.

  // Haiku 4.5 — kept for legacy alias resolution only (not shown in UI)
  HAIKU_4_5: 'claude-haiku-4-5',

  // Sonnet 5 — Everyday (all plans)
  CLAUDE_SONNET_5: 'claude-sonnet-5',

  // Legacy Sonnet ID — kept only so old persisted model strings (saved threads,
  // localStorage, cached automations) still compare equal to "Everyday" mode.
  // Resolves server-side via backend resolve_claude_model / CLAUDE_MODEL_MAPPINGS.
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',

  // Opus 5 — Smartest (all plans)
  CLAUDE_OPUS_5: 'claude-opus-5',

  // Legacy Opus IDs — kept only so old persisted model strings (saved threads,
  // automations, workflow steps) still compare equal to "Smartest" mode.
  // Resolves server-side via backend resolve_claude_model / CLAUDE_MODEL_MAPPINGS.
  CLAUDE_OPUS_4_8: 'claude-opus-4-8',
  CLAUDE_OPUS_4_7: 'claude-opus-4-7',

  // Sonnet 4.5 — kept for compatibility
  CLAUDE_SONNET_4_5: 'claude-sonnet-4-5',

  // Legacy aliases — kept for backward compatibility; resolve via backend resolve_claude_model
  CLAUDE_35_SONNET: 'claude-haiku-4-5',
  BEST: 'claude-haiku-4-5',
  FAST: 'claude-haiku-4-5',
  INSTANT: 'claude-haiku-4-5',
  LEGACY: 'claude-haiku-4-5',
};

// Legacy sentinel — used only to detect stale persisted Haiku spaces and upgrade them to Everyday.
export const DEFAULT_CLAUDE_MODEL = 'claude-haiku-4-5';

// ✅ Default model for all plans
export const DEFAULT_EXPERT_MODEL = CLAUDE_MODELS.CLAUDE_SONNET_5;

// "Everyday" is the default, all-purpose tier. To swap the underlying model in
// the future, change ONLY CLAUDE_MODELS.CLAUDE_SONNET_5 above (plus the
// matching backend alias in claude_config.py) — every UI surface that imports
// WHIZ_MODEL_ID / WHIZ_LABEL below picks up the change automatically.
export const WHIZ_MODEL_ID = DEFAULT_EXPERT_MODEL;
export const WHIZ_LABEL = 'Everyday';
export const WHIZ_MODEL_DISPLAY_NAME = 'Claude Sonnet 5';

// "Smartest" — deep-reasoning tier.
export const SMARTEST_MODEL_ID = CLAUDE_MODELS.CLAUDE_OPUS_5;
export const SMARTEST_LABEL = 'Smartest';
export const SMARTEST_MODEL_DISPLAY_NAME = 'Claude Opus 5';

// ✅ ONLY SUPPORTED MODELS - matches backend config
export const AVAILABLE_CLAUDE_MODELS = [
  { id: WHIZ_MODEL_ID, name: `${WHIZ_MODEL_DISPLAY_NAME} (${WHIZ_LABEL})` },
  { id: SMARTEST_MODEL_ID, name: `${SMARTEST_MODEL_DISPLAY_NAME} (${SMARTEST_LABEL})` },
];

// Combined list of all available models (Claude + other providers)
import { AVAILABLE_GROK_MODELS } from './grok';
import { AVAILABLE_DEEPSEEK_MODELS } from './deepseek';

export const ALL_AVAILABLE_MODELS = [
  ...AVAILABLE_CLAUDE_MODELS,
  ...AVAILABLE_GROK_MODELS,
  ...AVAILABLE_DEEPSEEK_MODELS,
];

